import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './Menu.module.scss'
import { Heading } from 'components/Heading'
import { MenuItem } from './MenuItem'
import { Stack } from 'components/Stack'

export const Menu: FC = (_props) => {
  const { t } = useTranslation()

  return (
    <Stack className={styles.menu}>
      <Heading align="right">{t('organization.heading')}</Heading>
      <nav>
        <Stack component="ul" space="medium">
          <MenuItem path="/organization/settings" text={t('organization.menu.settings')} />
          {/*<MenuItem
            path="/organization/legal-documents"
            text={t('organization.menu.legal_documents')}
          />*/}
        </Stack>
      </nav>
    </Stack>
  )
}

Menu.displayName = 'Menu'
